import { render, staticRenderFns } from "./TravelQuickInfo.vue?vue&type=template&id=32470d48&"
import script from "./TravelQuickInfo.vue?vue&type=script&lang=js&"
export * from "./TravelQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./TravelQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelQuickInfo.vue"
export default component.exports